import { EvaChart } from "constants/charts.enums";
import { EChartsOption } from "echarts";
import { EvaChartStates } from "types/factory";

import { boxPlotHighlightedOptions } from "./boxPlot";
import { crossPlotHighlightedSeries } from "./crossPlot";
import { baseLineWithSyncHighlightedSeries } from "./lineChartWithSync";
import { materialBalanceHighlightedSeries } from "./materialBalanceTime";
import { probitBalanceHighlightedSeries } from "./probit";
import { totalRateDateHighlightedSeries } from "./totalRateDate";
import { trendDateHighlightedSeries } from "./trendDate";
import { wellContributionHighlightedSeries } from "./wellContribution";

const HIGHLIGHT_SERIES_TRANSLATOR_MAP = {
  [EvaChart.RateCum]: baseLineWithSyncHighlightedSeries,
  [EvaChart.CumTime]: baseLineWithSyncHighlightedSeries,
  [EvaChart.RateDate]: baseLineWithSyncHighlightedSeries,
  [EvaChart.TotalRateDate]: totalRateDateHighlightedSeries,
  [EvaChart.RateTime]: baseLineWithSyncHighlightedSeries,
  [EvaChart.TotalRateCum]: baseLineWithSyncHighlightedSeries,
  [EvaChart.CAGR]: baseLineWithSyncHighlightedSeries,
  [EvaChart.DeclineRate]: baseLineWithSyncHighlightedSeries,
  [EvaChart.TrendDate]: trendDateHighlightedSeries,
  [EvaChart.MaterialBalanceTime]: materialBalanceHighlightedSeries,
  [EvaChart.Probit]: probitBalanceHighlightedSeries,
  [EvaChart.CrossPlot]: crossPlotHighlightedSeries,
  [EvaChart.BoxPlot]: boxPlotHighlightedOptions,
  [EvaChart.RateDateMidstream]: baseLineWithSyncHighlightedSeries,
  [EvaChart.TotalRateDateMidstream]: totalRateDateHighlightedSeries,
  [EvaChart.CrossPlotMidstream]: crossPlotHighlightedSeries,
  [EvaChart.WellContribution]: wellContributionHighlightedSeries,
  [EvaChart.TrendDateMidstream]: trendDateHighlightedSeries,
  [EvaChart.BoxPlotMidstream]: boxPlotHighlightedOptions,
  [EvaChart.RecoveryPVI]: baseLineWithSyncHighlightedSeries,
  [EvaChart.RecoveryTime]: baseLineWithSyncHighlightedSeries,
  [EvaChart.InjectorTotal]: trendDateHighlightedSeries
};

export function translateHighlightedSeriesOptions({
  type,
  states
}: {
  type: EvaChart;
  states: Partial<EvaChartStates>;
}): EChartsOption {
  const translator = HIGHLIGHT_SERIES_TRANSLATOR_MAP[type];
  if (!translator) {
    return {};
  }
  return translator(states);
}
